import { render, staticRenderFns } from "./EventDocumentModal.vue?vue&type=template&id=c96007b6&"
import script from "./EventDocumentModal.vue?vue&type=script&lang=js&"
export * from "./EventDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports